import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  ContactInfoHelp,
  BillingSetupHelp,
  CustomSettings,
  ServiceRatesHelp,
  ProductHelpCreate,
  ProductHelpEdit,
  HistoryHelp,
} from "./AccountHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const AccountCreateHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <ContactInfoHelp classes={classes} />;
    case "invoiceSetup":
      return <BillingSetupHelp classes={classes} />;
    case "customSettings":
      return <CustomSettings classes={classes} />;
    case "serviceRates":
      return <ServiceRatesHelp classes={classes} />;
    case "productCatalog":
      return <ProductHelpCreate classes={classes} />;
    default:
      return null;
  }
};

export const AccountEditHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <ContactInfoHelp classes={classes} />;
    case "invoiceSetup":
      return <BillingSetupHelp classes={classes} />;
    case "customSettings":
      return <CustomSettings classes={classes} />;
    case "serviceRates":
      return <ServiceRatesHelp classes={classes} />;
    case "productCatalog":
      return <ProductHelpEdit classes={classes} />;
    case "history":
      return <HistoryHelp classes={classes} />;
    default:
      return null;
  }
};
